/** https://beian.miit.gov.cn/ */
export const MIIT_BEIAN_LABEL = "蜀ICP备 2024076241号";
/** https://beian.mps.gov.cn/ */
export const MPS_BEIAN_CODE = 51010802001109;
